// 미배선·변경예정(TODO) 지점에 도달했을 때 개발자에게 구조화된 맥락을 남기는 **DEV 전용** 로거.
// prod 빌드에서는 no-op — `import.meta.env.DEV` 가드로 Vite 가 호출을 dead-code 제거한다.
//
// 흩어진 `[TODO:*]` console 마커를 한 형식으로 통일한다:
//   현재 **상태**(무엇으로 폴백·proxy 중인가) · 바뀌어야 할 **항목**(BE/FE 각각) ·
//   변경 가능 **시점**(어떤 BE 확정 후) · 런타임 **컨텍스트**.
// "지금 무엇이 임시이고 무엇을 기다리는가" 를 콘솔에서 일관되게 읽기 위함이다.
// ⚠️ 실제 관측해야 할 런타임 에러(api 5xx·network 등)는 이걸 쓰지 말고 `console.error` 를 유지한다.

export interface PendingTodo {
  /** 도달 트리거 — 페이지 진입 / 사용자 인터렉션 / 컴포넌트 표출. */
  trigger: 'page-enter' | 'interaction' | 'render';
  /** 현재 임시 동작 — 무엇으로 폴백·proxy 하고 있는가. */
  status: string;
  /** 바뀌어야 할 항목 — BE 인터페이스·FE 코드 각각 한 줄씩 (착수 가능하게 구체적으로). */
  changes: string[];
  /** 변경 가능 시점 — 어떤 BE 확정·배포로 풀리는가. */
  unblockedBy: string;
  /** 런타임 값 (plantId·productId·mock 토글 등). 선택. */
  ctx?: Record<string, unknown>;
}

/**
 * `[TODO:<id>]` 마커 + 상세 객체를 단일 `console.warn` 으로 출력 (DEV 에서만). 헤더에 트리거·상태를
 * 노출하고, 펼치면 `changes`/`unblockedBy`/`ctx` 전체를 본다 (상세 + 가독성).
 */
export function logPendingTodo(id: string, detail: PendingTodo): void {
  if (!import.meta.env.DEV) return;
  console.warn(`[TODO:${id}] (${detail.trigger}) ${detail.status}`, detail);
}
